/**
 * Footer component
 *
 * Displays avenues to contact you.
 * Contact information is passed in from the App component that
 * renders the Footer.
 *
 * If a social value has an empty string it will not be displayed.
 */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import devDotToIcon from "url:../images/socials/devdotto.svg";
import envelopeIcon from "url:../images/socials/envelope.svg";
import gitHubIcon from "url:../images/socials/github.svg";
import linkedInIcon from "url:../images/socials/linkedin.svg";
import mediumIcon from "url:../images/socials/medium.svg";

const frontendVersion = process.env.APP_VERSION || 'dev';

/**
 * 💡 Learning resources
 *
 *  HTML hyperlinks: https://www.w3schools.com/html/html_links.asp
 *  Opening links in new tabs: https://www.freecodecamp.org/news/how-to-use-html-to-open-link-in-new-tab/
 */

const Footer = ({
  devDotTo,
  email,
  gitHub,
  linkedIn,
  medium,
  name = "",
  primaryColor,
}) => {
  const [backendVersion, setBackendVersion] = useState(null);

  useEffect(() => {
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    fetch(`${apiBase}/api/health`)
      .then(res => res.json())
      .then(data => setBackendVersion(data.version || null))
      .catch(() => setBackendVersion(null));
  }, []);

  return (
    <div
      id="footer"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2.5rem",
        padding: "5rem 0 3rem",
        backgroundColor: "var(--accent)",
        width: "100vw"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "2.5rem",
        }}
      >
        {email && (
          <a href={`mailto:${email}`}>
            <img src={envelopeIcon} alt="email" className="socialIcon" />
          </a>
        )}
        {devDotTo && (
          <a href={`https://dev.to/${devDotTo}`} target="_blank" rel="noopener noreferrer">
            <img src={devDotToIcon} alt="Dev.to" className="socialIcon" />
          </a>
        )}
        {gitHub && (
          <a href={`https://github.com/${gitHub}`} target="_blank" rel="noopener noreferrer">
            <img src={gitHubIcon} alt="GitHub" className="socialIcon" />
          </a>
        )}
        {linkedIn && (
          <a
            href={`https://www.linkedin.com/in/${linkedIn}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedInIcon} alt="LinkedIn" className="socialIcon" />
          </a>
        )}
        {medium && (
          <a href={`https://medium.com/@${medium}`} target="_blank" rel="noopener noreferrer">
            <img src={mediumIcon} alt="Medium" className="socialIcon" />
          </a>
        )}
      </div>
      <p className="small" style={{ marginTop: 0, color: "white" }}>
        Created by {name}
      </p>
      <p className="small" style={{ marginTop: 0, color: "rgba(255,255,255,0.6)", fontSize: "0.75rem" }}>
        Frontend v{frontendVersion}{backendVersion ? ` · Backend v${backendVersion}` : ''}
      </p>
    </div>
  );
};

Footer.propTypes = {
  devDotTo: PropTypes.string,
  email: PropTypes.string,
  gitHub: PropTypes.string,
  linkedIn: PropTypes.string,
  medium: PropTypes.string,
  name: PropTypes.string.isRequired,
  primaryColor: PropTypes.string,

};

export default Footer;